export const bannerSpacer = "banner-spacer";
